import { render, staticRenderFns } from "./BackgroundExport.vue?vue&type=template&id=388e5b19&scoped=true&"
import script from "./BackgroundExport.vue?vue&type=script&lang=ts&"
export * from "./BackgroundExport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388e5b19",
  null
  
)

export default component.exports